import James from '../assets/speakers/headshot.png';
import Donne from '../assets/speakers/DONNE.png';
import Esquivel from '../assets/speakers/esquivel.jpg';
import Montserrat from '../assets/speakers/montserrat.png';

export const SpeakersList = [
  {
    id: 0,
    name: 'James Burrow',
    affiliation: 'University of Chicago, Argonne ACCESS',
    img: James,
    topic_id: 3,
    resume: '',
    title:
      'Energy Dense Sodium All-Solid-State Batteries from Materials Design to Interface Engineering.',
    abstract: '',
  },
  {
    id: 1,
    name: 'Scott donne',
    affiliation: 'University of Newcastle.',
    img: Donne,
    topic_id: 3,
    resume: '',
    title: 'Electrochemistry, particularly on energy-storage materials such as batteries, supercapacitors, and fuel cells.',
    abstract: '',
  },
  {
    id: 2,
    name: 'Juan P. Esquivel',
    affiliation: 'Ikerbasque Research Associate at BCMaterials',
    img: Esquivel,
    topic_id: 3,
    resume: '',
    abstract: '',
    title: 'Sustainable tailor-made power sources and self-powered devices.'
  },
  {
    id: 3,
    name: 'Montserrat Galceran',
    affiliation: 'CIC energi GUNE',
    img: Montserrat,
    topic_id: 3,
    resume: '',
    title: 'Research into sodium batteries and the direct recycling of lithium batteries.',
    abstract: '',
  },
];
